import Immutable from 'immutable';

const processConfigData = function(db, slotList) {
    if (!slotList || !slotList.length) {
        return db;
    }

    const mapDocumentFn = function(doc) {
        return {
            documentId: doc.dmsId,
            name: doc.type,
            pages: doc.pages,
            slotName: doc.slotName,
            clientHash: doc.clientHash
        };
    };

    const slots = Immutable.List(
        slotList.map(slot =>
            Immutable.Map({
                documents: Immutable.fromJS(slot.documents.map(mapDocumentFn))
            })
        )
    );

    const selectFirstIfSingle = function(_db) {
        const documents = slots.getIn([0, 'documents']);
        if (documents && documents.size === 1) {
            const document = slots.getIn([0, 'documents', 0]);
            return _db.setIn(['documentsUpload', 'model', 'selected', 0], document.set('active', true));
        }
        return _db;
    };

    return db
        .setIn(['documentsUpload', 'config'], slots)
        .setIn(['documentsUpload', 'model'], Immutable.Map())
        .setIn(['documentsUpload', 'model', 'slot'], 0)
        .update(selectFirstIfSingle);
};

const extractUploadedDocuments = function(documentsUploadModel) {
    if (!documentsUploadModel) {
        return null;
    }
    const files = documentsUploadModel.get('selected').reduce((acc, val) => {
        acc.push({
            docType: val.get('name'),
            slot: val.get('slotName')
        });
        return acc;
    }, []);

    return {
        files,
        version: documentsUploadModel.get('version')
    };
};

const hasEmptyConfig = function(db) {
    return !db.getIn(['documentsUpload', 'config']);
};

export default {
    hasEmptyConfig: hasEmptyConfig,
    processConfigData: processConfigData,
    processConfigDataUpdater: slotList => db => processConfigData(db, slotList),
    extractUploadedDocuments: extractUploadedDocuments
};
